import React from "react";
import {ReactComponent as Logo} from "images/emptyState/scribbles.svg";

export function Scribbles() {
  return <Logo />;
}
